// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4341":"76e1e6253700f766","6421":"69313ed06c33a335"}[chunkId] + ".css";
};